const lugaresEspaciosColectivos = [
  { id: "COLEGIO_INSTITUTO", nombre: "Colegio / Instituto" },
  { id: "GUARDERIA", nombre: "Guardería" },
  { id: "CENTRODEPORTIVO", nombre: "Centro deportivo" },
  { id: "LUDOTECA", nombre: "Ludoteca" },
  { id: "OTROS", nombre: "Otros" },
];

export default lugaresEspaciosColectivos;
